import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseUniversity extends BaseModel {
  static override constructorName = 'ResearchShowcaseUniversity'

  id: number = 0
  name: string = ''
  'university_short_faculties': string[] = []
  'university_short_departments': string[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseUniversity)
